import { h } from "preact";
import LinkList from "../link-list";

const FilmList = ({ ...props }) => (
  <LinkList
    database="film"
    dbType="list"
    resultLinkPath={props.resultLinkPath}
    resultLinkPathIdKey="id"
    textKey="titel"
    filterKey="titel"
    {...props}
  />
);

export default FilmList;
